<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center
  v-container(fluid)
    v-row(justify="center")
      v-col(cols=12 sm=8 md=12)
        v-row(justify="space-around" align="center")
          v-col(cols=12 md=6)
            v-img(
              src="../../assets/illustrations/erudio_certificate.svg"
              alt="Imagem aprendizado na palma da mão"
              transition="scroll-from-left-slow"
              min-height=190
            )
          v-col(cols=12 md=6)
            h3.mb-6.ibm.text-h4.text-md-h3.primary--text Vá além com o Erudio!
            p.text-body-1.text-md-h6.font-weight-regular.heebo.grey--text.text--darken-4 Além de ter seu próprio domínio, emita certificados de conclusão de seus cursos e engaje seus alunos por meio de um fórum personalizado.
            .text-body-1.text-md-h6.font-weight-regular.heebo.grey--text.text--darken-4 Tenha, de forma prática, relatórios e dados do seu negócio que farão você proporcionar uma experiência inesquecível para cada aluno.
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
